export default "__VITE_ASSET__036a34c6__"